module.exports = "<h1 mat-dialog-title>{{title}}</h1>\n<div mat-dialog-content>\n\t<p>{{message}}</p>\n</div>\n\n<div mat-dialog-actions>\n\t<button mat-button (click)=\"cancel()\">CANCEL</button>\n\t<button mat-raised-button (click)=\"ok()\" color=\"primary\">OK</button>\n</div>"


//////////////////
// WEBPACK FOOTER
// /Users/sofia/Documents/ng2-portals/ng2-firebase-toolkit-admin/src/app/common/dialogs/confirm.dialog.html
// module id = ../../../../../src/app/common/dialogs/confirm.dialog.html
// module chunks = main